import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { forwardRef } from '../../system';

import DisplayNames from './enums';

import { MenuItem, MenuItemProps, Box, Flex, Text, Icon } from 'index';

export type NavBarIconButtonItemProps = MenuItemProps & {
  iconType: string;
  header: string;
  subheader: string;
};

const NavBarIconButtonItem = forwardRef<NavBarIconButtonItemProps, 'div'>(
  (props: NavBarIconButtonItemProps, ref): React.ReactElement => {
    const { header, subheader, iconType, ...rest } = props;
    const navBarTheme = useMultiStyleConfig('NavBarTheme', props);

    return (
      <Box __css={navBarTheme.navBarIconButtonItem}>
        <MenuItem icon={<Icon boxSize="24px" type={iconType} />} ref={ref} {...rest}>
          <Flex direction="column">
            <Text as="span" color="silver.lightest" fontWeight="medium">
              {header}
            </Text>
            <Text as="span" color="grey.lightest" fontSize="sm">
              {subheader}
            </Text>
          </Flex>
        </MenuItem>
      </Box>
    );
  }
);

NavBarIconButtonItem.displayName = DisplayNames.NavBarIconButtonItem;

export default NavBarIconButtonItem;
